// Public: Allows to easily reuse common Crouton styles in the app.
export default {
  innerFormStyle: { croutonStyle: 'light left-aligned', closeBtn: false },
}
